// English translation

const en = {
  "menu.sale_validation": "SALES VALIDATION",
  "sale.state.draft": "Draft",
  "sale.state.processing": "Processing",
  "sale.state.succeeded": "Completed",
  "sale.state.failded": "Failed",
  "sale.state.draft.message": "The sale is in draft status.",
  "sale.state.processing.message": "The sale is being processed...",
  "sale.state.succeeded.message": "The sale was successfully confirmed!",
  "sale.state.failded.message": "The sale has failed. Please try again.",
};

export default en;
